const CHILD_IDENTIFIER = "IframeBridgeChild"
const PARENT_IDENTIFIER = "IframeBridgeParent"

const MESSAGE_READY = "ready"
const MESSAGE_INIT = "init"
const MESSAGE_UPDATE = "update"

/**
 * @param {HTMLElement} iframe Iframe element
 * @param {any} value Data to be passed to the iframe [can be reactive object]
 * @returns
 */
export function initBridgeParent(iframe, value, onReady) {
    if (!iframe) {
        console.warn("No iframe provided")
        return
    }
    const listener = (event) => {
        if (
            event.data?.target === PARENT_IDENTIFIER &&
            event.data?.data === MESSAGE_READY
        ) {
            if (process.server) return
            if (!iframe?.contentWindow) {
                console.warn("No iframe content window found")
                return
            }
            window.$iframeData = value
            iframe.contentWindow.postMessage({
                target: CHILD_IDENTIFIER,
                data: MESSAGE_INIT,
            })
            onReady?.()
            console.info("IframeBridge: Parent initialized")
        }
    }
    window.addEventListener("message", listener)
    console.info("IframeBridge: Parent ready")
    return {
        unregister: () => {
            window.removeEventListener("message", listener)
            console.info("IframeBridge: Parent unregistered")
        },
        update(data) {
            window.$iframeData = data
            iframe.contentWindow.postMessage({
                target: CHILD_IDENTIFIER,
                data: MESSAGE_UPDATE,
            })
        },
    }
}

/**
 * @returns {Promise<iframeData>} Promise that resolves to the data passed to the parent
 */
export function initBridgeChild(updateFn) {
    if (!parent) {
        console.warn("No parent window found")
        return
    }
    const promise = new Promise((resolve) => {
        window.addEventListener("message", (event) => {
            if (
                event.data?.target === CHILD_IDENTIFIER &&
                event.data?.data === MESSAGE_INIT
            ) {
                console.info("IframeBridge: Child initialized")
                resolve(parent.$iframeData)
            }
            if (
                event.data?.target === CHILD_IDENTIFIER &&
                event.data?.data === MESSAGE_UPDATE
            ) {
                console.debug("IframeBridge: Child updated")
                updateFn?.(parent.$iframeData)
            }
        })
    })
    parent.postMessage({ target: PARENT_IDENTIFIER, data: MESSAGE_READY }, "*")
    console.info("IframeBridge: Child ready")
    return promise
}
